/**
 * Deadlines component JS.
 */

import { h, app } from 'hyperapp'

( function( $ ) {

	if ( ! document.querySelector('#deadlines__app') ) {
		return
	}

	const state = {
		visible: 0,
		subtitle: 'Stay on Track',
		title: '',
		excerpt: '',
		table: '',
		footnotes: '',
		link: '',
		tableHeaders: [],
		tableRows: []
	}

	const actions = {
		updateState: value => state => ({
			visible: value.visible,
			subtitle: value.subtitle ? value.subtitle : state.subtitle,
			title: value.title,
			link: value.link,
			tableHeaders: value.tableHeaders ? value.tableHeaders : state.tableHeaders,
			tableRows: value.tableRows ? value.tableRows : state.tableRows,
			footnotes: value.footnotes,
			excerpt: value.excerpt
		})
	}

	const Text = ({ title, subtitle, excerpt, link }) => (
		<div className="deadlines__text">
			<p className="subtitle">{subtitle}</p>
			<h3>{title}</h3>
			<p className="excerpt">{excerpt}</p>
			<a className="outline-button" href={link}>View Program</a>
		</div>
	)

	const Table = ({ headers, rows, footnotes }) => {

		if ( 0 < headers.length ) {

			return (
				<div class="deadlines__table">
					<table>
						<thead>
							<tr>
								{headers.map(({ c }) => (
									<th>{c}</th>
								))}
							</tr>
						</thead>
						{rows.map(row => (
							<tr>
								{row.map(({ c }, i) => (
									<td data-label={headers[ i ]['c']}>{c}</td>
								))}
							</tr>
						))}
					</table>
					<div class="deadlines__footnotes">{footnotes}</div>
				</div>
			)

		} else {

			return (
				<div class="deadlines__table">
					<p class="deadlines__no-deadlines">There are currently no deadlines set for this program.</p>
				</div>
			)

		}

	}

	const view = (state, actions) => {

		let visibleStyles = ! state.visible ? { display: 'none' } : {}

		return (
			<div className="deadlines__app-container" style={visibleStyles}>
				<Text title={state.title} subtitle={state.subtitle} excerpt={state.excerpt} link={state.link} />
				<Table headers={state.tableHeaders} rows={state.tableRows} footnotes={state.footnotes} />
			</div>
		)
	}

	const App = app( state, actions, view, document.getElementById('deadlines__app') )

	$( document ).ready(() => {

		if ( document.getElementById('deadlines__program') ) {
			let programId = document.getElementById('deadlines__program').getAttribute('data-id')

			let requestUrl = ajax_object.api_url + 'program/' + programId

			$.ajax({
				method: 'GET',
				url: requestUrl,
				success: function( post ) {

					if ( 'undefined' !== typeof post['id'] ) {
						let deadlinesTable = JSON.parse( post['deadlines'] )

						App.updateState({
							visible: 1,
							title: post['title']['rendered'],
							link: post['link'],
							tableHeaders: deadlinesTable['h'],
							tableRows: deadlinesTable['b'],
							footnotes: post['deadlines_footnotes'],
							excerpt: post['excerpt']
						})

					}

				}
			});
		}

	})

	$( document ).on( 'click', '.deadlines__select-header', (e) => {

		let $select = e.currentTarget.parentNode.parentNode

		if ( $select.classList.contains('active') ) {
			$select.classList.remove('active')
			return
		}

		$('.deadlines__select').removeClass('active')
		$select.classList.toggle('active')
	})

	$( document ).on( 'click', '.deadlines__select-dropdown-item', function() {
		let $select = $( this ).parents('.deadlines__select')
		updateDropdownMenu( this, $select )
	})

	const updateDropdownMenu = ( $li, $select ) => {
		let title = $li.textContent
		$( $select ).find('.deadlines__select-header').removeClass('unselected').text( title )
		$select.toggleClass('active')

		let degreeId = $li.getAttribute('data-degree-id')

		// When a heafdegree is selected.
		if ( null !== degreeId ) {
			let $programsHeader = document.querySelector('#deadlines-select-program .deadlines__select-header')
			$programsHeader.innerHTML = 'Choose a Program'
			$programsHeader.classList.add('unselected')

			let requestUrl = ajax_object.api_url + 'program?degree=' + degreeId

			$.ajax({
				method: 'GET',
				url: requestUrl,
				success: function( posts ) {
					updateProgramsList( posts );
				}
			});

			// Hide App.
			App.updateState({ visible: 0 })
		}
	}

	const updateProgramsList = ( posts ) => {

		// Remove disabled from button
		document.querySelector('#deadlines-select-program .deadlines__select-header').removeAttribute('disabled')

		let $dropdown = document.querySelector('#deadlines-select-program .deadlines__select-dropdown')
		$dropdown.innerHTML = '';

		for ( var i = posts.length - 1; i >= 0; i-- ) {

			if ( 0 === parseInt( posts[ i ]['has_deadlines'] ) ) {
				continue;
			}

			// Create List Item.
			let $li = document.createElement('li')
			let textNode = document.createTextNode( posts[ i ]['title']['rendered'] )
			$li.appendChild( textNode )
			$li.setAttribute( 'data-id', posts[ i ]['id'] )
			$li.classList.add('deadlines__select-dropdown-item')

			$li.onclick = showDeadlines( posts[ i ] );

			$dropdown.appendChild( $li )
		}
	}

	const showDeadlines = ( post ) => () => {
		let deadlinesTable = JSON.parse( post['deadlines'] )

		App.updateState({
			visible: 1,
			title: post['title']['rendered'],
			link: post['link'],
			tableHeaders: deadlinesTable['h'],
			tableRows: deadlinesTable['b'],
			footnotes: post['deadlines_footnotes'],
			excerpt: post['excerpt']
		})
	}

} ( jQuery ) );



// WEBPACK FOOTER //
// ./assets/js/components/layout/deadlines.js